import React, { useEffect, useState } from "react";
import "../../styles/Countdown.scss";

export default function Countdown() {
  const calculateTimeLeft = () => {
    const target = new Date("May 27, 2027 10:00:00").getTime();
    const now = new Date().getTime();
    const difference = target - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="countdown-section">
      <div className="countdown-wrapper">
        <div className="time-box">
          <span className="time-number">{timeLeft.days}</span>
          <span className="time-label">Days</span>
        </div>

        <span className="colon">:</span>

        <div className="time-box">
          <span className="time-number">{timeLeft.hours}</span>
          <span className="time-label">Hours</span>
        </div>

        <span className="colon">:</span>

        <div className="time-box">
          <span className="time-number">{timeLeft.minutes}</span>
          <span className="time-label">Minutes</span>
        </div>

        <span className="colon">:</span>

        <div className="time-box">
          <span className="time-number">{timeLeft.seconds}</span>
          <span className="time-label">Seconds</span>
        </div>
      </div>
    </section>
  );
}
